export default "__VITE_ASSET__B2UbSpfA__"